import React from "react";
import { observer } from "mobx-react";
import { SignedEditionSadaicWorkflowStateCreateStore } from "../../store";
import { SignedEditionSadaicWorkflowStateCreateForm } from "./SignedEditionSadaicWorkflowStateCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type SignedEditionSadaicWorkflowStateCreateProps = {
  signedEditionSadaicWorkflowStateCreateStore: SignedEditionSadaicWorkflowStateCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const SignedEditionSadaicWorkflowStateCreate: React.FC<SignedEditionSadaicWorkflowStateCreateProps> =
  observer(
    ({
      signedEditionSadaicWorkflowStateCreateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay
            open={signedEditionSadaicWorkflowStateCreateStore.isSaving}
          />
          <SignedEditionSadaicWorkflowStateCreateForm
            signedEditionSadaicWorkflowStateCreateStore={
              signedEditionSadaicWorkflowStateCreateStore
            }
            name_esError={
              signedEditionSadaicWorkflowStateCreateStore.errors.name_es
                ?.message
            }
            onName_esChange={(value: string) => {
              signedEditionSadaicWorkflowStateCreateStore.setName_esValue(
                value
              );
            }}
            name_es={
              signedEditionSadaicWorkflowStateCreateStore.entityValues.name_es
            }
            name_enError={
              signedEditionSadaicWorkflowStateCreateStore.errors.name_en
                ?.message
            }
            onName_enChange={(value: string) => {
              signedEditionSadaicWorkflowStateCreateStore.setName_enValue(
                value
              );
            }}
            name_en={
              signedEditionSadaicWorkflowStateCreateStore.entityValues.name_en
            }
            name_ptError={
              signedEditionSadaicWorkflowStateCreateStore.errors.name_pt
                ?.message
            }
            onName_ptChange={(value: string) => {
              signedEditionSadaicWorkflowStateCreateStore.setName_ptValue(
                value
              );
            }}
            name_pt={
              signedEditionSadaicWorkflowStateCreateStore.entityValues.name_pt
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={signedEditionSadaicWorkflowStateCreateStore.isProcessing}
            onSave={() =>
              signedEditionSadaicWorkflowStateCreateStore.saveNewSignedEditionSadaicWorkflowState()
            }
            onCancel={() =>
              signedEditionSadaicWorkflowStateCreateStore.cancelNewSignedEditionSadaicWorkflowState()
            }
          />
          <ErrorDialog
            open={signedEditionSadaicWorkflowStateCreateStore.errorDialogOpened}
            title={signedEditionSadaicWorkflowStateCreateStore.errorTitle}
            description={
              signedEditionSadaicWorkflowStateCreateStore.errorDescription
            }
            onClose={() =>
              signedEditionSadaicWorkflowStateCreateStore.closeErrorDialog()
            }
          />
        </>
      );
    }
  );
